export default __webpack_public_path__ + "static/media/running.bf7e438f.jpg";